export const SETTINGS_TABLE_PAGE_SIZE = 10
export const SETTINGS_TABLE_PAGE_SIZE_OPTIONS = [
  SETTINGS_TABLE_PAGE_SIZE,
  25,
  50,
]
